<div
  class="menu-user-top"
  *appShowOn="{ tablet: true, desktop: true, largeDesktop: true }"
>
  <div
    class="filter user-trigger pendo-nav-account-trigger"
    [matMenuTriggerFor]="userMenu"
    matTooltip="Account"
    matTooltipPosition="below"
  >
    <mat-icon>person</mat-icon>
  </div>

  <div
    class="filter pendo-nav-manual-button"
    (click)="openManual()"
    matTooltip="Manual"
    matTooltipPosition="below"
    *ngIf="showGuide"
  >
    <mat-icon>menu_book</mat-icon>
  </div>

  <mat-menu #userMenu="matMenu" xPosition="before" class="user-top-menu-panel">
    <ng-template matMenuContent>
      <div class="account-head" (click)="$event.stopPropagation()">
        <div class="name" [matTooltip]="displayName" matTooltipPosition="above">
          {{ displayName }}
        </div>
        <div class="email-row">
          <span class="email">{{ userInfo.user?.email }}</span>
          <span
            class="token-chip"
            *ngIf="routing.isDev()"
            (click)="getToken()"
            matTooltip="Copy user's token to clipboard"
            matTooltipPosition="above"
          >
            <mat-icon>vpn_key</mat-icon>
            <span>Token</span>
          </span>
        </div>
      </div>

      <div class="divider"></div>

      <button
        id="menu-account-user-settings"
        mat-menu-item
        class="user-top-item pendo-account-user-settings"
        (click)="openUserSettingsPopup()"
      >
        <span class="material-icons-outlined">settings</span>
        <span>User settings</span>
      </button>

      <button
        mat-menu-item
        class="user-top-item pendo-account-admin"
        *ngIf="userInfo.isAdmin"
        (click)="onUserAdministration()"
      >
        <mat-icon>recent_actors</mat-icon>
        <span>{{ 'MENU_ACCOUNT.ADMIN' | translate }}</span>
      </button>

      <div class="user-top-item theme-row" (click)="$event.stopPropagation()">
        <div class="label">
          <span class="material-icons-outlined"
            >{{ routing.theme === 'dark' ? 'bedtime' : 'wb_sunny' }}</span
          >
          <span>Theme</span>
        </div>
        <div class="theme-toggle">
          <span class="theme-caption"
            >{{ routing.theme === 'dark' ? 'Dark' : 'Light' }}</span
          >
          <mat-slide-toggle
            class="pendo-account-theme-toggle"
            [checked]="routing.theme === 'dark'"
            (change)="toggleTheme($event.checked)"
          ></mat-slide-toggle>
        </div>
      </div>

      <div class="divider"></div>

      <button
        *ngIf="!config.appConfig.urlLoginRedirect"
        mat-menu-item
        class="user-top-item logout pendo-account-logout"
        routerLink="/logout"
      >
        <mat-icon>exit_to_app</mat-icon>
        <span>{{ 'MENU_ACCOUNT.LOGOUT' | translate }}</span>
      </button>
    </ng-template>
  </mat-menu>
</div>
